import { optional } from '@library/common/functions';

import { MockPath } from '@library/common/http/mock-path.mock';

import { AdminAccountsRoutes } from './account/admin-accounts.routes.mock';
import { AdminUserRoutes } from './user/admin-user.routes.mock';

import { MockSourceSystem } from './admin-enum.mock';

export const AdminRoutes: MockPath<unknown>[] = [
   ...AdminAccountsRoutes,
   ...AdminUserRoutes,

   { path: 'enum/admin/(.*)/source-systems', verb: 'GET', collection: _ => [ MockSourceSystem() ] },

   { path: 'enum/admin/(.*)/services', verb: 'GET', collection: _ =>
      MockSourceSystem().services
      // SourceSystems[ opts?.captured[0] ?? 'customer' ].map( s => s.services )
         .reduce(( a, c ) => [ ...a, c ], [] )
         .filter(( v, i, a ) => a.map( j => j.id ).indexOf( v.id ) === i )
         .map( s => ({ id: s.id, service: s.service }))
   },

   { path: 'enum/admin/(.*)/.*/account-services', verb: 'GET', collection: _ =>
      MockSourceSystem().services
      // SourceSystems[ opts?.captured[0] ?? 'customer' ].map( s => s.services )
         .reduce(( a, c ) => [ ...a, c ], [] )
         .map( s => ({ id: s.id, service: s.service }))
         .filter( _ => optional( 60 ))
   }
];
